var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h6',[_vm._v(_vm._s(_vm.exception.title))]),_c('span',[_vm._v(_vm._s(_vm.exception.detail))])])
}
var staticRenderFns = []

export { render, staticRenderFns }